var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7276 23.9468L22.1016 20.6646C21.7382 20.2103 21.1438 20.2103 20.7804 20.6646L19.3866 22.4068C19.0526 22.8243 18.5228 22.8683 18.1512 22.5038C17.3542 21.722 16.5002 20.7971 15.6312 19.7108C14.7622 18.6246 14.0223 17.5571 13.3967 16.5608C13.1051 16.0964 13.1401 15.4341 13.4743 15.0166L14.8682 13.2744C15.2316 12.8201 15.2316 12.0771 14.8682 11.6229L12.2425 8.34068C11.8791 7.88644 11.2847 7.88644 10.9213 8.34068L10.2079 9.23267C6.88852 13.3819 11.2119 19.3231 13.5769 22.279C15.9418 25.235 20.6946 30.6395 24.0142 26.49L24.7276 25.5983C25.0908 25.1443 25.0908 24.401 24.7276 23.9468Z",
    fill: "#006DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0d4a066949b9977953dec2dc2ec597ff.svg";
export { ForwardRef as ReactComponent };